import type { Transition, Variants } from "framer-motion";

// Shared motion presets so the whole app moves the same way.
// Keep these subtle: short durations, small distances.

export const ease = [0.22, 1, 0.36, 1] as const; // easeOutQuint-ish

export const spring: Transition = { type: "spring", stiffness: 420, damping: 34, mass: 0.8 };

export const quick: Transition = { duration: 0.18, ease };

/** Fade + small rise, for items entering a page or list. */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.24, ease } },
  exit: { opacity: 0, y: -4, transition: { duration: 0.14, ease } },
};

/** Parent for staggered lists. Use with `fadeUp` on children. */
export const stagger = (staggerChildren = 0.035, delayChildren = 0): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren, delayChildren } },
});

/** Hover/tap feedback for cards. */
export const cardHover = {
  whileHover: { y: -2 },
  whileTap: { scale: 0.99 },
  transition: spring,
};

/** Tap feedback for buttons. */
export const press = {
  whileTap: { scale: 0.97 },
  transition: spring,
};
